import { Record } from "graphql/generated/graphql";
import { checkBundleItemType, checkProjectItemType } from "utils/utils";

export const baseResourceBody = `
    id
    name
    description
    record_type
    is_readonly
    is_project_readonly
    is_bundle_readonly
    project_id
    bundle_id
    created_at
    created_by_identity{
        identity_type
        id
        name
        is_deleted
    }
    modified_at
    record_version
    modified_by_identity{
        identity_type
        id
        name
        is_deleted
    }
    deleted_at
    track_in_git
    pending_trash_identity_id
    pending_restore_identity_id
    pending_delete_identity_id
    comment_count
`;

export const locationField = (
    recordType: Record["record_type"] | Lowercase<Record["record_type"]>
) => {
    const isProject = checkProjectItemType(recordType.toUpperCase());
    const isBundle = checkBundleItemType(recordType.toUpperCase());

    const variables = {
        variables: `
        ${isProject ? "$project_id: String," : ""}
        ${isBundle ? "$bundle_id: String," : ""}`,
        query: `
        ${isProject ? "project_id: $project_id," : ""}
        ${isBundle ? "bundle_id: $bundle_id," : ""}`,
    };

    return variables;
};

export default {
    graphql: {
        resourceBody: `
            ${baseResourceBody}
            project_id_project {
                id
                name
                icon
                workspace_id
                is_readonly
                force_track_in_git
                deleted_at
                branch_name
            }
            bundle_id_bundle {
                id
                name
                icon
                is_readonly
                force_track_in_git
                workspace_id
                deleted_at
                branch_name
            }
            workspace_id_workspace {
                id
                name
                branch_name
                repository_name
            }
            record_metadata_list_record_id (limit: 0, order: "+id", offset: 0) {
                record_metadata_count
            }
            record_comment_list_record_id (limit: 0, order: "+id", offset: 0) {
                record_comment_count
            }
        `,
        createVariables: (type) => `
            $name: String,
            ${locationField(type).variables}
            $description: String,
            $track_in_git: Boolean,
        `,
        createQuery: (type) => `
            name: $name,
            ${locationField(type).query}
            description: $description,
            track_in_git: $track_in_git
        `,
        updateVariables: (type) => `
            $id: String!,
            $by: String,
            $name: String,
            ${locationField(type).variables}
            $description: String,
            $is_readonly: Boolean,
            $track_in_git: Boolean,
        `,
        updateQuery: (type) => `
            name: $name,
            ${locationField(type).query}
            description: $description,
            is_readonly: $is_readonly,
            track_in_git: $track_in_git
        `,
    },
};
